import React from 'react';
import { Popup } from 'react-leaflet';
import parse from 'html-react-parser';
import { MarkerInfo } from '../../../../../core/types/types';

interface MarkerPopupProps {
    markerModalBody: string;
}

const MarkerPopup: React.FC<MarkerPopupProps> = ({ markerModalBody }) => {
    return (
        <Popup autoPan={false}>
            <div style={{ textAlign: 'right' }}>{parse(markerModalBody)}</div>
        </Popup>
    );
};

export default MarkerPopup;
